import CombatEncounter from "@frog/source/models/CombatEncounter.js"

export default class Game {
    static update(game, delta) {
        if(game.encounter != undefined
        && game.encounter.update != undefined) {
            game.encounter.update(delta)
        }
    }
    static load(game) {
        if(game.encounter != undefined) {
            game.encounter = CombatEncounter.load({
                "encounter": game.encounter,
                "player": game.player,
                "chapterParty": game.chapterParty
            })
        }
        return game
    }
}
